import React, { useState } from 'react'
import { INode } from 'shared/types/tree'
import { Box, Button } from '@mui/material'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { updateValidationsAtom, validationsTreeAtom } from './atoms'
import { useEditableTreeForProduct } from '../../../api/tree.hooks'
import { TreeValidations } from './updates/TreeValidations'

export function MasterUpdateValidation({ productId }: { productId: number }) {
  const { tree } = useEditableTreeForProduct(productId)
  if (!tree) return <Box>Loading...</Box>
  return <MasterUpdateValidationTree tree={tree} />
}

function MasterUpdateValidationTree({ tree }: { tree: INode }) {
  useSetAtom(validationsTreeAtom)(tree)

  return (
    <Box>
      <Box padding={'5px'}>{`${tree.tree_id}:${tree.version}`}</Box>
      <SwitchState />
    </Box>
  )
}

function SwitchState() {
  const [getValidations, setGetValidations] = useState(false)
  if (getValidations) {
    return <LoadingState />
  }

  return (
    <Box padding="20px">
      Press button to
      <Box>
        <Button onClick={() => setGetValidations(true)}>Get Validations</Button>
      </Box>
      This might take a little while, please be patient
    </Box>
  )
}

function LoadingState() {
  const validations = useAtomValue(updateValidationsAtom)

  if (!validations) {
    return <Box>Loading...</Box>
  }
  return (
    <Box>
      <TreeValidations validations={validations} showAll={true} />
    </Box>
  )
}
